module.exports = __webpack_public_path__ + "media/images/redesign-images/home/carousel/business-desktop-7b52511a8ab9713b8ab7dfb488cf3f8f.jpg";